import { RelevoInterface } from '../../../../api/types';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { ScanItemInfo } from '../components/ScanItemInfo';
import { ScanStateLayout } from '../components/ScanStateLayout';
import { getIconPath } from '../utils/state.helper';

type DuplicateStateProps = {
  onAnimationComplete: () => void;
  item?: RelevoInterface;
  progressResetKey?: string | number;
};

export const DuplicateState = ({ item, onAnimationComplete, progressResetKey }: DuplicateStateProps) => {
  const translations = useTranslations();

  return (
    <ScanStateLayout
      heading={translations('scan_modal_duplicate_heading')}
      imageSrc={getIconPath('warning.svg')}
      onAnimationComplete={onAnimationComplete}
      progressResetKey={progressResetKey}
    >
      {item ? <ScanItemInfo item={item} /> : null}
    </ScanStateLayout>
  );
};
